import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SkeletonService } from '../shared/services/skeleton.service';
import { environment } from '../../environments/environment';
import { ApiService } from '../shared/services/apiService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { SeoService } from '../shared/seo/seo.service';
import { CanonicalService } from '../shared/seo/canonical.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  @ViewChild('cardElement') cardElement: ElementRef;
  breadcrumbdata: any[];
  environment1 = environment.s3bucket.url;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public skeletonService: SkeletonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,private behaviourSubject:BehaviourSubjectService,
    private spinner: NgxSpinnerService,
    private localStorage: secureStorage,private seoservice: SeoService,private canonicalservice: CanonicalService

  ) { }

  categoryType: string
  showBreadCrumb: boolean = false;



  imageUrls: any = [];
  cfrnt_url: string;
  videoData: any[] = [];
  viewall: any[] = [];
  vehicleNumber: any = [];
  lob: any;
  ppl: any;
  sub_lob;
  height: number=0;
  width: number=0;
  isMobile: boolean;
  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1200,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },

  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

    }
    this.showBreadCrumb = true;
    this.behaviourSubject.isSmart.next(false);
    this.route.paramMap.subscribe((params) => {
   this.categoryType = params.get('categoryType');
   this.fetchBannerData();
    this.fetchCategooryData()
    this.breadcrumb();
  });
  }

  fetchBannerData() {
    const requestData = {
      page: 'CATEGORY',
      brand_type:this.categoryType,
      offset: 0,
      size: 6,
      source:this.isMobile ? 'webapp':'web'
    };
    this.spinner.show();
    this.apiService.getBannerData(requestData).subscribe({
      next: (res) => {
        if (res.success) {
          this.cfrnt_url = res.cfrnt_url
           this.imageUrls = res.data;
      const url = this.router.url;
      const trimmedUrl = url.startsWith('/') ? url.substring(1) : url;
    

      this.canonicalservice.createCanonicalURL(trimmedUrl);
        }
        else{
          this.imageUrls = [];
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error fetching banner data', err);
      },
    });
  }
  fetchCategooryData() {
    const requestData = {
      category:"BRAND",
      category_type: this.categoryType,
    };
    this.spinner.show();
    this.apiService.getBannerVideoData(requestData).subscribe({
      next: (res) => {
        if (res.success) {
          this.viewall = res.data.banner_data;

        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching banner data', err);
        this.spinner.hide();
      },
    });
  }

  breadcrumb() {
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata = [];
    var breadcrumbList1 = {
      label: this.categoryType,
      url: `/category/`,
    };
    this.breadcrumbdata.push(breadcrumbList1);

    this.localStorage.setItem(
      'localBreadCrumb',
      JSON.stringify(this.breadcrumbdata)
    );
    this.showBreadCrumb = true;
    this.seoservice.callSchema();
  }

  gotobrand(data:any){
    this.router.navigateByUrl('/brand/' + data['title']?.toLowerCase());
 }

 updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
  if (!isPlatformBrowser(this.platformId)) {
    return imageUrl;
  }

  if (!imageUrl) {
    return '';
  }

  if (!element) {
    return imageUrl;
  }

  try {
    // Get actual width & height of the card
    const actualWidth = width && width > 0 ? width : element.clientWidth || 300;  // Default to 300 if no width
    const actualHeight = height && height > 0 ? height : element.clientHeight || 200;  // Default to 200 if no height
  
    
    const imgWidth = Math.floor(actualWidth * 0.8);
    const imgHeight = Math.floor((imgWidth / 100) * 67);
  
  

    // Ensure the URL is properly formatted
    const baseUrl = imageUrl.split('/resize/')[0];  // Get the base URL without resize parameters
    if (!baseUrl) {
      return imageUrl;
    }

    const updatedUrl = `${baseUrl}/resize/${imgWidth}x${imgHeight}`;
  
  

    return updatedUrl;
  } catch (error) {
    return imageUrl;  // Return original URL if there's an error
  }
}
}
